
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("gSAPV"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("gSAPV", function(module, exports) {

let $c49e43728fa4e87e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c49e43728fa4e87e$var$load("h3ABO"),
    $c49e43728fa4e87e$var$load("9hYRW"),
    $c49e43728fa4e87e$var$load("kpm7S"),
    $c49e43728fa4e87e$var$load("5wC2D"),
    $c49e43728fa4e87e$var$load("2YffH"),
    $c49e43728fa4e87e$var$load("g7ggm"),
    $c49e43728fa4e87e$var$load("eEyVs"),
    $c49e43728fa4e87e$var$load("6mHrv"),
    $c49e43728fa4e87e$var$load("awWN9"),
    $c49e43728fa4e87e$var$load("9CYct"),
    $c49e43728fa4e87e$var$load("80qAe"),
    $c49e43728fa4e87e$var$load("9hf2S"),
    $c49e43728fa4e87e$var$load("hZtKG"),
    $c49e43728fa4e87e$var$load("dkqvW"),
    $c49e43728fa4e87e$var$load("lVO3w"),
    $c49e43728fa4e87e$var$load("hyzoX"),
    $c49e43728fa4e87e$var$load("h9Ed7"),
    $c49e43728fa4e87e$var$load("eBRUf"),
    $c49e43728fa4e87e$var$load("kbRvk"),
    $c49e43728fa4e87e$var$load("tKhaz"),
    $c49e43728fa4e87e$var$load("cD6Zr"),
    $c49e43728fa4e87e$var$load("k3jER"),
    $c49e43728fa4e87e$var$load("9wzNh"),
    $c49e43728fa4e87e$var$load("8YSo7"),
    $c49e43728fa4e87e$var$load("hwT9D"),
    $c49e43728fa4e87e$var$load("j4Bpe"),
    $c49e43728fa4e87e$var$load("9ldRJ"),
    $c49e43728fa4e87e$var$load("50ame"),
    $c49e43728fa4e87e$var$load("7do1E"),
    $c49e43728fa4e87e$var$load("77dkW"),
    $c49e43728fa4e87e$var$load("1MlIV"),
    $c49e43728fa4e87e$var$load("6iz6l"),
    $c49e43728fa4e87e$var$load("4SCW2"),
    $c49e43728fa4e87e$var$load("eukPA"),
    $c49e43728fa4e87e$var$load("9QSJH"),
    $c49e43728fa4e87e$var$load("Wowvf"),
    $c49e43728fa4e87e$var$load("421lv"),
    $c49e43728fa4e87e$var$load("dek7I"),
    $c49e43728fa4e87e$var$load("3SmkN"),
    $c49e43728fa4e87e$var$load("dYtBN"),
    $c49e43728fa4e87e$var$load("kNV5Y"),
    $c49e43728fa4e87e$var$load("6wr18"),
    $c49e43728fa4e87e$var$load("kjZZD"),
    $c49e43728fa4e87e$var$load("99Ppz"),
    $c49e43728fa4e87e$var$load("5v2fx"),
    $c49e43728fa4e87e$var$load("fkb26"),
    $c49e43728fa4e87e$var$load("37ldp"),
    $c49e43728fa4e87e$var$load("ffEVr"),
    $c49e43728fa4e87e$var$load("9AXkC"),
    $c49e43728fa4e87e$var$load("28arV"),
    $c49e43728fa4e87e$var$load("hhss7"),
    $c49e43728fa4e87e$var$load("lkwGP"),
    $c49e43728fa4e87e$var$load("fGPXi"),
    $c49e43728fa4e87e$var$load("dP7ao"),
    $c49e43728fa4e87e$var$load("hogcU"),
    $c49e43728fa4e87e$var$load("dkgtP"),
    $c49e43728fa4e87e$var$load("g43Ev"),
    $c49e43728fa4e87e$var$load("7EorR"),
    $c49e43728fa4e87e$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.68311272.js.map
